module.exports = "app-agenda-weekly full-calendar .fc-toolbar.fc-header-toolbar {\n  margin-bottom: 1em; }\n"